import {
  getArticleContent,
  getArticleVotes,
} from '@backmarket/http-api/src/api-specs-content'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

import { usePageParamsFromRoute } from '../../../cms/composables/usePageParamsFromRoute'

function useFetchVotes() {
  const { pageName } = usePageParamsFromRoute()

  return useHttpFetch(getArticleVotes, {
    pathParams: { articleSlug: pageName },
  })
}

function useFetchContent() {
  const pathParams = usePageParamsFromRoute()

  return useHttpFetch(getArticleContent, { pathParams })
}

export async function useFetchArticle() {
  const [fetchedContent, fetchedVotes] = await Promise.all([
    useFetchContent(),
    useFetchVotes(),
  ])

  return { fetchedContent, fetchedVotes }
}
